module.exports = __webpack_public_path__ + "static/media/peterArt9.dba85e9c.jpg";